import i18n from "@/i18n";
import { db, storage } from "@/firebase/firebase";
import axios from "axios";
import moment from "moment";

export const handleGetAllDevices = async (payload, callback) => {
  const url = `${payload.host}/devices.json?auth=${payload.secret}`;
  const request = axios({
    method: "get",
    url: url,
  });

  try {
    const result = await request;
    const data = Object.values(result.data);
    callback(data);
  } catch (err) {
    console.error(err);
    throw new Error(i18n.t("errors.authError"));
  }

  // try {
  //   const url = `${payload.host}/devices.json?auth=${payload.idToken}`;

  //   await axios({
  //     method: "get",
  //     url: url,
  //   })
  //     .then((result) => {
  //       console.log(result);
  //       const data = Object.values(result.data);
  //       callback(data);
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //       throw new Error(
  //         "That URL was not valid or we couldnt find any devices 😔"
  //       );
  //     });
  // } catch {
  //   throw new Error("That URL was not valid or we couldnt find any devices 😔");
  //   // console.error(err);
  //   // if (err === "Network Error") {
  //   //   throw new Error(
  //   //     "That URL was not valid or we couldnt find any devices 😔"
  //   //   );
  //   // }
  // }
};

export const handleUploadFirmware = async (payload) => {
  try {
    const ref = storage.ref("Firmwares").child(payload.id);
    console.log(payload);
    await ref
      .listAll()
      .then((dir) => {
        dir.items.forEach((fileRef) => {
          ref.child(fileRef.name).delete();
        });
      })
      .then(() => {
        return ref
          .child(payload.name)
          .put(payload.file)
          .then((uploadTaskSnapshot) => {
            return uploadTaskSnapshot.ref.getDownloadURL();
          })
          .then((fileUrl) => {
            axios({
              method: "patch",
              url: `${payload.host}/devices/${payload.id}/firmware/.json?auth=${payload.secret}`,
              data: {
                url: fileUrl,
                update: 1,
                uploadDate: moment(new Date()).format("hh:mmA, DD/MM/YY"),
                fileName: payload.name,
              },
            });
          })
          .then(() => {
            return db
              .ref("uploads")
              .child(payload.id)
              .set({
                id: payload.id,
                status: 1,
                name: payload.name,
              });
          })
          .catch((error) => {
            console.error("Error uploading file: ", error);
          });
      });
  } catch {
    throw new Error("There was an error uploading your file");
  }
};

export const handleDeleteFirmware = async (payload) => {
  try {
    const ref = storage.ref("Firmwares").child(payload.id);

    await ref
      .child(payload.name)
      .delete()
      .then(() => {
        return db
          .ref("devices")
          .child(payload.id)
          .remove();
      })
      .then(() => {
        return db
          .ref("chartData")
          .child(payload.id)
          .remove();
      });
  } catch (err) {
    console.log(err);
  }
};
